import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Surfaced in the console during local dev if the .env isn't set up yet.
  console.warn('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are missing — set them in .env.local');
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  // Late-bound so the network layer can be stubbed (MSW, browser tests);
  // identical behavior in production.
  global: { fetch: (...args) => fetch(...args) },
});

export const supabaseConfigured = Boolean(url && anonKey);
